// Compatibility shim for react-i18next v9 which doesn't have useTranslation hook
// Returns a simple t() function that returns the key as-is (Albanian strings used directly)
import { useCallback } from 'react'

export function useTranslation() {
  const t = useCallback((key) => key, [])
  return { t }
}
